module.exports = __webpack_public_path__ + "officialStatic/img/money-first.31daa6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/money-first.png
// module id = wTbc
// module chunks = 0